/** Model edge over the fair (devigged) probability. */
export const edge = (pModel, pFair) => pModel - pFair;

/** Expected value per unit stake at the given price. */
export const ev = (pModel, price) => pModel * price - 1;

/** A bet clears both the edge and EV thresholds. */
export function isActive({ pModel, pFair, price }, { minEdge = 0.03, minEv = 0.02 } = {}) {
  return edge(pModel, pFair) >= minEdge && ev(pModel, price) >= minEv;
}
